// composable: useUserApi.ts
import { inject, InjectionKey } from 'vue';
import { HistoryApiService } from './historyApiService';

export const HISTORY_API_KEY: InjectionKey<HistoryApiService> = Symbol('HistoryApiService');

export function useHistoryApi(): HistoryApiService {
    const service = inject<HistoryApiService>(HISTORY_API_KEY);
    if (!service) throw new Error('HistoryApiService not provided');
    return service;
}
